import { useDocumentTitle } from "@/hooks/useDocumentTitle"

/** Renders nothing; keeps the browser tab title in sync with the current page. */
export function DocumentTitleSync(): null {
  useDocumentTitle()
  return null
}
